import { axiosInstance } from '@/utils/api'
import { IWorkcenter } from '@/utils/types/model/workcenter'

interface IWorkcenterListResponse {
  totalRecords: number
  workcenterMasters: IWorkcenter[]
}

export async function getWorkcenters(
  page: number,
  limit: number,
  code?: string,
  sortBy?: string,
  sortType?: string
): Promise<IWorkcenterListResponse> {
  const params: Record<string, unknown> = {
    page,
    limit,
  }

  if (code) {
    params.code = code
  }

  if (sortBy) {
    params.sortBy = sortBy
  }

  if (sortType) {
    params.sortType = sortType
  }

  const response = await axiosInstance.get('/workcenters', { params })
  return response.data
}

export async function exportWorkcenters(data: { sortBy?: string; sortType?: string }) {
  const response = await axiosInstance.post('/workcenters/export', data)
  return response.data
}
